import React from 'react';
import { Link } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function ReportCard({ name, description, icon, to }) {
  return (
    <Link
      to={to}
      className="group h-full bg-white rounded-xl border border-gray-200 shadow-sm p-4 flex items-start gap-4 hover:border-[#E8B4C4] hover:shadow-md transition focus:outline-none focus-visible:ring-2 focus-visible:ring-claret-500"
    >
      <div className="h-11 w-11 shrink-0 rounded-lg bg-[#FBEFF3] text-claret-500 flex items-center justify-center text-2xl">
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-900 group-hover:text-claret-500">
          {name}
        </p>
        <p className="text-xs text-gray-500 mt-1 leading-relaxed">
          {description}
        </p>
      </div>
      <ChevronRightIcon className="self-center text-gray-300 group-hover:text-claret-500 group-hover:translate-x-0.5 transition-transform" />
    </Link>
  );
}

export default ReportCard;
